/*
    整改审批、立项审批、非项目问题审批、祥版报告审批、问题详情五个页面公共的方法
*/


/*
    用途：时间戳转日期对象
    @param {number} timeStamp - 时间戳  值示例：1697010424099
    @param {string} type - 返回数据格式  值示例：chinese 或 rail
    @return {string}    值示例: 2024年04月30日  或 2024-04-30
*/
export function timeStampTransformDate(timeStamp,type){
    let date = new Date(timeStamp)
    let year = date.getFullYear()
    let month = date.getMonth() + 1
    month = month < 10 ? '0' + month : month
    let day = date.getDate()
    day = day < 10 ? '0' + day : day

    if(type != "rail") `${year}年${month}月${day}日`
    return `${year}-${month}-${day}`
}

/*
    用途：时间戳转日期对象
    @param {string} time - 时间日期  值示例：20240506
    @return {string}    值示例: 2024年04月30日  或 2024-04-30
*/
export function timeTransformDate(time){
    const timeString = time.toString();
    const year = timeString.slice(0,4);
    const month = timeString.slice(4,6);
    const day = timeString.slice(6,8);
    
    return `${year}-${month}-${day}`
}

/*
    用途：数字等级转换为中文
    @param {number} level - 数字等级  10
    @return {string} 
*/
export function levelTramform(level){
    switch(level){
        case 10: return "一级";
        case 20: return "二级";
        case 30: return "三级";
        case 40: return "特别重大";
    }
}

/*
    用途：数字申请事项转中文名
    @param {number} num - 数字等级  10
    @return {string} 
*/
export function applyStagesTramform(num){
    switch(num){
        case 1: return "申请办结";
        case 2: return "申请延期";
        case 4: return "取消跟踪";
    }
}

/*
    用途：问题分类数字转中文名
    @param {string} num - 数字等级  '10'
    @return {string} 
*/
export function problemTypeTramform(num){
    switch(num){
        case '1': return "制度机制类";
        case '2': return "操作执行类";
        case '11': return "制度流程设计";
        case '12': return "制度流程执行";
        case '13': return "IT与数据问题";
        case '14': return "法律合规问题";
        case '15': return "错误和遗漏";
        case '16': return "舞弊行为";
        case '17': return "不当行为";
        case '21': return "潜在的内部控制缺陷";
        case '22': return "潜在的违法风险";
        case '23': return "潜在的财务风险";
        case '24': return "潜在的供应链风险";
        case '25': return "潜在的信息安全风险";
    }
}
